import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface PolicyContent {
  title?: string;
  intro?: string;
  intro2?: string;
  intro3?: string;
  consent?: any;
  informationWeCollect?: any;
  howWeUseYourInformation?: any;
  logFiles?: any;
  cookiesAndWebBeacons?: any;
  advertisingPartnersPrivacyPolicies?: any;
  thirdPartyPrivacyPolicies?: any;
  ccpaPrivacyRights?: any;
  gdprDataProtectionRights?: any;
  howCanYourDataBeDeleted?: any;
  childrensInformation?: any;
}

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit, OnDestroy {
  content: PolicyContent = {};
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.loadContent();
    // Reload content when language changes
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadContent());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadContent(): void {
    this.translate.get('policies.privacy')
      .pipe(takeUntil(this.destroy$))
      .subscribe(content => {
        this.content = content;
      });
  }

}
